(function (angular) {

  angular
    .module("app")
    .directive("alkAutofocus", ["$timeout", "$parse", function ($timeout, $parse) {
      return {
        restrict: "A",
        link: function ($scope, $element, attrs) {
          if (attrs.alkAutofocus === "" || $parse(attrs.alkAutofocus)($scope)) {
            $timeout(function () {
              $element[0].focus();
            }, 0);
          }
        }
      };
    }]);

})(angular);



// WEBPACK FOOTER //
// ./app/components/focus.directive.js